import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { initialStatus, StatusRequest, successStatus } from '../../../../../../core/models/request-status.model';
import { CustomActiveCartService } from '../../../_core/active-cart.service';
import { isEmpty } from '../../../../../../core/services/simple-tools';

@Component({
  selector: 'cart-empty',
  templateUrl: './cart-empty.component.html',
  styleUrl: './cart-empty.component.scss',
  standalone: false,
})
export class CartEmptyComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  cartRequest$ = new BehaviorSubject<StatusRequest>(initialStatus);

  constructor(private customActiveCartService: CustomActiveCartService) {}

  ngOnInit(): void {
    this.checkCart();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkCart() {
    this.subscription.add(
      this.customActiveCartService.getActive().subscribe(cart => {
        isEmpty(cart.code) && this.cartRequest$.next(successStatus);
      }),
    );
  }
}
